var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/FormulaInput.styled.ts";
import styled, { css } from 'styled-components';
import { Editable as EditableInit } from 'slate-react';
export const Content = styled.div`
  position: relative;
`;
export const Backdrop = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  background: #eee;
  opacity: 0.3;
`;
export const HighlightOffWrapper = styled.div`
  position: absolute;
  ${props => !props.disabled && 'cursor: pointer'};
  right: 10.5px;
  top: 10.5px;
  display: flex;
  align-items: center;
  justify-content: center;

  & path {
    opacity: 0.25;
    transition: all ease-out 0.2s;
    fill: #353b60;
  }

  &:hover {
    & path {
      ${props => !props.disabled && 'opacity: 1'};
    }
  }
`;
export const Editable = styled(EditableInit)`
  min-height: 40px;
  background: #fff;
  border-radius: 4px;
  transition: all ease-out 0.2s;
  border: ${props => props.error ? '1px solid #D9575E' : '1px solid transparent'};

  &:hover {
    border: 1px solid #c5c6d1;
  }

  &:focus {
    border: 1px solid #4c5ecf;
    box-shadow: 0px 5px 10px rgba(53, 60, 96, 0.1);
  }

  & p[data-slate-node='element'] {
    padding: ${props => props.existMention ? '3px 35px 2px 9px' : '9px 35px 7px 12px'};
    margin: 0;
  }

  & span[data-slate-leaf='true'] {
    span {
      font-weight: 500 !important;
      font-size: 13px;
      color: rgba(53, 59, 96);
    }

    & span[data-slate-string='true'] {
      color: #353b60;
    }
  }

  ${props => props.disabled && css`
      pointer-events: none;
    `}
`;